import { buildEndpoint } from './base.endpoints';

const BASE = '/Reports';

export const drillReportEndpoints = {
  drill: () => buildEndpoint(`${BASE}/timesheet-drill`),
  drillSummary: () => buildEndpoint(`${BASE}/timesheet-drill/summary`),
  drillExport: () => buildEndpoint(`${BASE}/timesheet-drill/export`),
  // Raw paths for buildEndpointWithQuery
  drillPath: () => `${BASE}/timesheet-drill`,
  drillSummaryPath: () => `${BASE}/timesheet-drill/summary`,
  drillExportPath: () => `${BASE}/timesheet-drill/export`,
} as const;

export default drillReportEndpoints;
